module.exports = __webpack_public_path__ + "static/media/Keynote-Ajit_Rajwade.5da1aa56.png";